/* Progressive, page-scoped UI only. The original page script owns inventory,
   variant fallback and cart requests. No additional purchase/network calls. */
(function(){
  'use strict';
  var page=document.querySelector('.cl-ip');
  if(!page)return;
  var grid=page.querySelector('#ip-grid');
  var dialog, dialogImage, dialogCaption, opener;
  if(typeof HTMLDialogElement!=='undefined'&&HTMLDialogElement.prototype.showModal){
    dialog=document.createElement('dialog');dialog.className='cl-ip__lightbox';dialog.setAttribute('aria-label','Imperfection photo');
    var close=document.createElement('button');close.type='button';close.textContent='Close photo';close.addEventListener('click',function(){dialog.close()});
    dialogImage=document.createElement('img');dialogCaption=document.createElement('p');dialogCaption.id='ip-photo-caption';dialog.setAttribute('aria-describedby',dialogCaption.id);
    dialog.appendChild(close);dialog.appendChild(dialogImage);dialog.appendChild(dialogCaption);page.appendChild(dialog);
    dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
    dialog.addEventListener('close',function(){if(opener)opener.focus()});
  }
  page.querySelectorAll('.cl-ip__exg').forEach(function(group){
    var handle=group.getAttribute('data-h');if(handle)group.id='ip-example-'+handle;
    group.querySelectorAll('figure').forEach(function(figure){
      var img=figure.querySelector('img'),caption=figure.querySelector('figcaption');if(!img||!caption)return;
      img.alt=caption.textContent.trim();
      var control=document.createElement(dialog?'button':'a');control.className='cl-ip__photo';control.setAttribute('aria-label','View larger photo: '+caption.textContent.trim());
      if(dialog){control.type='button';control.setAttribute('aria-haspopup','dialog');control.addEventListener('click',function(){opener=control;var url=new URL(img.currentSrc||img.src,location.href);url.searchParams.set('width','1400');dialogImage.src=url.href;dialogImage.alt=img.alt;dialogCaption.textContent=caption.textContent;dialog.showModal()})}
      else{control.href=img.src;control.target='_blank';control.rel='noopener'}
      img.parentNode.insertBefore(control,img);control.appendChild(img);
    });
  });
  function update(){
    if(!grid)return;
    grid.querySelectorAll('.cl-ip__card').forEach(function(card){
      var name=card.querySelector('.cl-ip__name');if(!name)return;
      card.querySelectorAll('.cl-ip__opt').forEach(function(opt){
        var label=opt.querySelector('.cl-ip__lab'),group=opt.querySelector(':scope > div');if(!label||!group)return;
        group.setAttribute('role','group');group.setAttribute('aria-label',name.textContent+' '+label.getAttribute('data-name'));
        group.querySelectorAll('.cl-ip__chip').forEach(function(chip){chip.setAttribute('aria-pressed',chip.classList.contains('is-on')?'true':'false')});
      });
      var productHref=name.getAttribute('href')||card.getAttribute('href')||'';
      var handle=productHref.split('/').pop();var example=handle?page.querySelector('#ip-example-'+handle):null;
      card.querySelectorAll('.cl-ip__link').forEach(function(link){if(link.getAttribute('href')==='#examples'&&example)link.href='#'+example.id});
      var done=card.querySelector('.cl-ip__done'),err=card.querySelector('.cl-ip__err');
      if(done){done.setAttribute('role','status');done.setAttribute('aria-live','polite')}
      if(err)err.setAttribute('role','alert');
    });
  }
  update();
  if(grid){
    new MutationObserver(update).observe(grid,{childList:true,subtree:true});
    grid.addEventListener('click',function(e){if(e.target.closest('.cl-ip__chip'))update()});
  }
})();
